<template>
  <div
    class="customizer-header aisea-mt-9 aisea-mb-8 flex items-center justify-between aisea-pr-9 aisea-pl-9"
  >
    <menu-title :menuTitle="menuTitle" />
    <feather-icon-button
      class="menu-bar-x-icon"
      :clickFunction="closeSidebar"
      iconName="XIcon"
    />
  </div>
</template>

<script>
/**
 * メニューのタイトルとXアイコンのコンポーネント
 * @parent O.RightMenuBase
 * @props menuTitle: String メニューに表示するタイトル
 * @props closeSidebar: Function メニューを閉じる関数
 */
import FeatherIconButton from "@/components/atoms/FeatherIconButton";
import MenuTitle from "@/components/atoms/MenuTitle";
export default {
  name: "M.MenuBar",
  components: {
    FeatherIconButton,
    MenuTitle,
  },
  props: {
    menuTitle: {
      type: String,
      required: true,
    },
    closeSidebar: {
      typr: Function,
      required: false,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.menu-bar-x-icon {
  color: $aisea-pure-white;
  border-radius: 3px;

  &:hover {
    background-color: #595d69;
  }

  &:active {
    background-color: #8b8e97;
  }
}
</style>
